import { Action, createFeatureSelector, createSelector } from '@ngrx/store';
import { DisplayMessageMinimum } from '../../common';
import { IFixedPrice } from '../IFixedPrice';
import * as actions from './actions';

export interface State {
    fpinvoices: Array<IFixedPrice>;
    errors: Array<string>;
}

export const initialState: State = {
    fpinvoices: [],
    errors: []
};

export function reducer(
    state = initialState,
    action: actions.ActionsUnion
): State {
    switch (action.type) {
        case actions.ActionTypes.SetFixedPrice:
            return {
                ...state,
                fpinvoices: [...action.payload]
            };
        // case actions.ActionTypes.UpdateFixedPrice:
        //  return { //Delete the row if the dftid is -1
        //    ...state,
        //    fpinvoices: state.fpinvoices.slice()
        //  }
        case actions.ActionTypes.UpdateFixedPriceSuccess:
            const fpresp = action.payload;
            return {
                ...state,
                fpinvoices: state.fpinvoices
                    // problem here when the dftid for multiple rows is -1
                    .map<IFixedPrice>(
                        x =>
                            fpresp.Items.find(
                                y => y.UniqueID === x.UniqueID
                            ) || {
                                ...x
                            }
                    ) // update any existing
                    .concat(
                        fpresp.Items.filter(
                            x =>
                                !state.fpinvoices.find(
                                    y => y.UniqueID === x.UniqueID
                                )
                        )
                    ), // add any new
                errors: fpresp.ErrorMessages
            };
        case actions.ActionTypes.DeleteFixedPriceSuccess:
            const deleresp = action.payload;
            return {
                ...state,
                fpinvoices: state.fpinvoices, // need to remove the deleted fixed price from the state
                errors: [
                    ...deleresp.ErrorMessages,
                    ...deleresp.Items.filter(
                        x => x.Status.StatusCode >= DisplayMessageMinimum
                    ).map(x => x.Status.Message)
                ]
            };
        default:
            return state;
    }
}
const StateFeatureSelector = createFeatureSelector<State>('fpinvoices');

export const getFixedPrice = createSelector(
    StateFeatureSelector,
    x => x.fpinvoices
);
export const getFixedPriceErrors = createSelector(
    StateFeatureSelector,
    x => x.errors
);
